import React from "react";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { createStore, applyMiddleware, compose } from "redux";
import Main from "./Main";
import rootReducer from "./reducers";
import thunk from "redux-thunk";
import { Provider } from "react-redux";

const store = createStore(rootReducer, compose(applyMiddleware(thunk), process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f));

const theme = createMuiTheme({
  palette: {
    primary: {
      light: "#4791db",
      main: "#1976d2",
      dark: "#115293",
    },
    secondary: {
      main: "#f44336",
    },
  },
  typography: {
    useNextVariants: true,
  },
});

const user = localStorage.getItem('un');
const tokenId = localStorage.getItem('saat');
const refreshToken = localStorage.getItem('srat');

export default function App(props) {
  console.log("Versão 0.0.1");

  return (
    <Provider store={store}>
      <MuiThemeProvider theme={theme}>
        <Main tokenId={tokenId} user={user} refreshToken={refreshToken} />
      </MuiThemeProvider>
    </Provider>
  );
}
